import {endpointKeys} from '@common/api'
import {PractitionerSummary} from '@common/models'
import {practitionerSummariesNormaliser} from '@common/normalisers'

import {useWebGet, useApi} from './helpers'

/**
 * Hook to get practitioners managed by partner administrator
 * Calls GET /api/v1/partner-administrators/practitioners
 */
export const useGetPartnerAdminPractitioners = (activeOnly = true) => {
  const endpoint = useApi().partnerAdminPractitioners()
  if (activeOnly) {
    endpoint.searchParams.set('activeOnly', 'true')
  }

  return useWebGet<PractitionerSummary[]>(
    [endpointKeys.partnerAdminPractitioners, {activeOnly}],
    endpoint,
    practitionerSummariesNormaliser,
  )
}
